module.exports = __webpack_public_path__ + "h5/img/icon_zx_y.a1baa394.png";